import { useState, useEffect } from "react";
import { MapPin, Globe, Users, Accessibility, Baby, Heart } from "lucide-react";

export const TIER_ORDER = ["domestic", "international", "couples", "family", "accessible", "young_children"];

export const TIER_META = {
  domestic: { short: "Domestic", icon: MapPin, blurb: "Trips anywhere in the continental United States." },
  international: { short: "International", icon: Globe, blurb: "Travel abroad — bigger budgets, farther horizons." },
  family: { short: "Family of 4+", icon: Users, blurb: "One spot for the whole family of four, plus add extra people." },
  accessible: { short: "Accessible", icon: Accessibility, blurb: "Continental US trips planned around disability and mobility needs." },
  young_children: { short: "Young Children", icon: Baby, blurb: "Continental US trips built for kids under 12 and their grown-ups." },
  couples: { short: "Couples", icon: Heart, blurb: "Romance-first escapes for two — candlelit dinners, suites and sunsets." },
};

export const LEVEL_LABEL = { standard: "Standard", premium: "Premium" };

export const PLAN_LABEL = { solo: "1 person", duo: "2 people", family: "Family of 4" };

export const useTier = () => {
  const [tier, setTier] = useState(() => {
    const t = localStorage.getItem("vq_tier");
    return TIER_ORDER.includes(t) ? t : "domestic";
  });
  useEffect(() => { localStorage.setItem("vq_tier", tier); }, [tier]);
  return [tier, setTier];
};

export const partySize = (plan, extra = 0) => ({ solo: 1, duo: 2, family: 4 }[plan] + (plan === "family" ? extra : 0));
